import React from "react";
import { Container, Row, Col, Accordion, Button } from "react-bootstrap";
import Card from "../../../components/Card";

const PrivacyPolicy = () => {
  return (
    <Container fluid id="privacyAccordion">
      <Row>
        <Col lg="12">
          <Accordion className="mm-accordion faq-style" defaultActiveKey="0">
            {/* Introduction & Scope */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingIntro">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="0"
                      >
                        <span>Introduction & Scope</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="0" className="accordion-details">
                <p className="mb-0">
                  This Privacy Policy describes how{" "}
                  <strong>Leapfrog Software Technology Africa PLC</strong>{" "}
                  (“Leapfrog”, “we”, “us”, or “our”) collects, uses, shares, and
                  protects personal data when you use our website, platforms
                  (including EZIBUS), or interact with us. It also explains your
                  rights regarding that data.
                </p>
              </Accordion.Collapse>
            </Card>

            {/* What Data We Collect */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingData">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="1"
                      >
                        <span>What Data We Collect</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="1" className="accordion-details">
                <p className="mb-0">
                  We may collect information such as:
                  <ul>
                    <li>Contact details: name, email address, phone number</li>
                    <li>Account and login information</li>
                    <li>
                      Usage data: pages visited, actions taken, times,
                      device/browser info
                    </li>
                    <li>
                      Transaction and billing details (when you use paid
                      services)
                    </li>
                    <li>Communications and feedback you provide</li>
                    <li>Cookies and similar technologies to track usage</li>
                  </ul>
                </p>
              </Accordion.Collapse>
            </Card>

            {/* How We Use Data */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingUse">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="2"
                      >
                        <span>How We Use Your Data</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="2" className="accordion-details">
                <p className="mb-0">
                  We use collected data for purposes including:
                  <ul>
                    <li>
                      Operating and delivering our services (like EZIBUS,
                      telecom, software)
                    </li>
                    <li>
                      Communicating with you (updates, support, notifications)
                    </li>
                    <li>Analyzing and improving how our systems are used</li>
                    <li>Fraud detection, security, risk management</li>
                    <li>
                      Marketing & promotional communications (where you agree)
                    </li>
                    <li>Compliance with legal or regulatory obligations</li>
                  </ul>
                </p>
              </Accordion.Collapse>
            </Card>

            {/* Data Sharing & Disclosure */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingSharing">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="3"
                      >
                        <span>Data Sharing & Disclosure</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="3" className="accordion-details">
                <p className="mb-0">
                  We may share your information with:
                  <ul>
                    <li>
                      Service providers or partners who help us run our
                      operations (under confidentiality)
                    </li>
                    <li>
                      Affiliates, subsidiaries, or other parts of the
                      organization
                    </li>
                    <li>
                      When required by law or in response to legal requests
                    </li>
                    <li>
                      In connection with business transfers (mergers,
                      acquisitions)
                    </li>
                  </ul>
                </p>
              </Accordion.Collapse>
            </Card>

            {/* Your Rights */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingRights">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="4"
                      >
                        <span>Your Rights</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="4" className="accordion-details">
                <p className="mb-0">
                  You have rights such as:
                  <ul>
                    <li>
                      Accessing and obtaining a copy of the data we hold about
                      you
                    </li>
                    <li>Correcting or updating data that’s inaccurate</li>
                    <li>Requesting deletion of your data (where permitted)</li>
                    <li>Restricting or objecting to certain processing</li>
                    <li>
                      Withdrawing consent (where processing is based on consent)
                    </li>
                    <li>Data portability, where applicable</li>
                  </ul>
                </p>
              </Accordion.Collapse>
            </Card>

            {/* Data Retention & Security */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingRetention">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="5"
                      >
                        <span>Data Retention & Security</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="5" className="accordion-details">
                <p className="mb-0">
                  We keep personal data only as long as needed for the purposes
                  for which it was collected, or as required by law. We
                  implement appropriate technical and organizational measures to
                  safeguard your data from unauthorized access, use, alteration,
                  or destruction.
                </p>
              </Accordion.Collapse>
            </Card>

            {/* Contact Information */}
            <Card className="mm-accordion-block">
              <div className="active-faq clearfix" id="headingContact">
                <Container fluid>
                  <Row>
                    <Col sm="12">
                      <Accordion.Toggle
                        as={Button}
                        href="#"
                        bsPrefix="accordion-title"
                        eventKey="6"
                      >
                        <span>Contact Us</span>
                      </Accordion.Toggle>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Accordion.Collapse eventKey="6" className="accordion-details">
                <p className="mb-0">
                  Leapfrog Software Technology Africa PLC <br />
                  Addis Ababa, Ethiopia <br />
                  Arada Sub-City, Woreda 01 <br />
                  Email: info@leapfrogtechafrica.com <br />
                  Phone: +251 111263569 / +251 710028383
                </p>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
